export enum TYPE_DRAGLIST {
  MULTI = 'multi',
  SINGLE = 'single'
}

export class DragItem {
  constructor(public value, public index, public id) {}
}

export class DragList {
  masterList = false;
  type = TYPE_DRAGLIST.MULTI;
  emptyMessage = 'Empty List';
  ulClass = '';
  liClass = '';
  values: DragItem[] = [];
  previousLength = 0;
  constructor(public dragKey, args?) {
    if (args) {
      this.masterList = args.masterList != null ? args.masterList : this.masterList;
      this.type = args.type != null ? args.type : this.type;
      this.emptyMessage = args.emptyMessage != null ? args.emptyMessage : this.emptyMessage;
      this.ulClass = args.ulClass != null ? args.ulClass : this.ulClass;
      this.liClass = args.liClass != null ? args.liClass : this.liClass;

      if (args.values && args.values.length > 0) {
        this.values = args.values.map((element: {value: any, id?: number, index?: number}, i) => {
          return new DragItem(element.value, element.index != null ? element.index : i, element.id);
        });
        this.previousLength = this.values.length;
      }
    }
  }
}

export class DragObject {
  dragListObject: any = {};
  dragBag = 'dragBag';
  constructor(dragBag?, dragListObject?: {dragKey: string, args: any}[]) {
    this.dragBag = dragBag != null ? dragBag : this.dragBag;
    if (dragListObject && dragListObject.length > 0) {
      dragListObject.forEach((element: {dragKey: string, args: any}) => {
        this.dragListObject[element.dragKey] = new DragList(element.dragKey, element.args);
      });
    }
  }

  setDragList (dragKey, args?) {
    this.dragListObject[dragKey] = new DragList(dragKey, args);
  }
}
